// @flow
import { combineReducers } from 'redux';
import { AsyncRequest, createReducer } from 'angieslist-app-platform';
import inboxActionKeys from './inboxActionKeys';

const initialInboxEnabledState = false;
const initialAutomationEnabledState = false;
const initialShowHeaderState = true;
const initialUnreadMessageCountState = 0;

export default (combineReducers({
  getInboxHtml: AsyncRequest.createReducer(inboxActionKeys.GET_INBOX_PAGE, {
    [inboxActionKeys.GET_INBOX_PAGE_SUCCESS]: (state, action) => (
      AsyncRequest.setSuccess(state, action.payload)
    ),
    [inboxActionKeys.GET_INBOX_PAGE_ERROR]: (state, action) => (
      AsyncRequest.setError(state, action.payload)
    ),
  }),
  getAutomationMessage: AsyncRequest.createReducer(inboxActionKeys.GET_AUTOMATION_MESSAGE, {
    [inboxActionKeys.GET_AUTOMATION_MESSAGE_SUCCESS]: (state, action) => (
      AsyncRequest.setSuccess(state, action.payload)
    ),
    [inboxActionKeys.GET_AUTOMATION_MESSAGE_ERROR]: (state, action) => (
      AsyncRequest.setError(state, action.payload)
    ),
  }),
  setAutomationMessage: AsyncRequest.createReducer(inboxActionKeys.SET_AUTOMATION_MESSAGE, {
    [inboxActionKeys.SET_AUTOMATION_MESSAGE_SUCCESS]: (state, action) => (
      AsyncRequest.setSuccess(state, action.payload)
    ),
    [inboxActionKeys.SET_AUTOMATION_MESSAGE_ERROR]: (state, action) => (
      AsyncRequest.setError(state, action.payload)
    ),
  }),
  getAutomationTemplates: AsyncRequest.createReducer(inboxActionKeys.GET_AUTOMATION_TEMPLATES, {
    [inboxActionKeys.GET_AUTOMATION_TEMPLATES_SUCCESS]: (state, action) => (
      AsyncRequest.setSuccess(state, action.payload)
    ),
    [inboxActionKeys.GET_AUTOMATION_TEMPLATES_ERROR]: (state, action) => (
      AsyncRequest.setError(state, action.payload)
    ),
  }),
  unreadMessageCount: createReducer(initialUnreadMessageCountState, {
    [inboxActionKeys.SET_UNREAD_MESSAGE_COUNT]: (state, action) => action.payload,
    [inboxActionKeys.GET_UNREAD_MESSAGE_COUNT_SUCCESS]: (state, action) => (
      action.payload.body.unreadCount
    ),
  }),
  isAutomationEnabled: createReducer(initialAutomationEnabledState, {
    [inboxActionKeys.SET_IS_AUTOMATION_ENABLED]: (state, action) => action.payload,
  }),
  isInboxEnabled: createReducer(initialInboxEnabledState, {
    [inboxActionKeys.SET_IS_INBOX_ENABLED]: (state, action) => action.payload,
  }),
  shouldShowHeader: createReducer(initialShowHeaderState, {
    [inboxActionKeys.SET_SHOULD_SHOW_HEADER]: (state, action) => action.payload,
  }),
}): any);



// WEBPACK FOOTER //
// ./src/modules/inbox/common/inboxReducer.js